import { render } from "./EditItemDialog.vue?vue&type=template&id=efd4fe26"
import script from "./EditItemDialog.vue?vue&type=script&lang=js"
export * from "./EditItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__